import { Handle, Position } from "@xyflow/react";
import { Input, Select } from "antd";
import { PictureOutlined } from "@ant-design/icons";

const { Option } = Select;

const MediaNode = ({ data, selected }) => {
  const onChange = (field, value) => data.onChange?.({ ...data, [field]: value });

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#f59e0b" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    }}>
      <Handle type="target" position={Position.Left} style={{ background: "#f59e0b" }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <PictureOutlined style={{ color: "#f59e0b", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Media</strong>
      </div>

      <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Media Type</label>
      <Select
        value={data.mediaType || "image"}
        onChange={(v) => onChange("mediaType", v)}
        size="small"
        style={{ width: "100%", marginBottom: 8 }}
      >
        <Option value="image">Image</Option>
        <Option value="video">Video</Option>
        <Option value="audio">Audio</Option>
        <Option value="document">Document</Option>
      </Select>

      <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>URL</label>
      <Input
        value={data.url || ""}
        onChange={(e) => onChange("url", e.target.value)}
        placeholder="https://..."
        size="small"
        style={{ marginBottom: 8 }}
      />

      <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Caption (optional)</label>
      <Input
        value={data.caption || ""}
        onChange={(e) => onChange("caption", e.target.value)}
        placeholder="Caption..."
        size="small"
      />

      <Handle type="source" position={Position.Right} style={{ background: "#f59e0b" }} />
    </div>
  );
};

export default MediaNode;
